const time = new Intl.DateTimeFormat('ru', { hour: '2-digit', minute: '2-digit' });
const dayMonth = new Intl.DateTimeFormat('ru', { day: 'numeric', month: 'long' });
const fullDate = new Intl.DateTimeFormat('ru', { day: 'numeric', month: 'long', year: 'numeric' });
const shortDate = new Intl.DateTimeFormat('ru', { day: '2-digit', month: '2-digit', year: '2-digit' });
const weekday = new Intl.DateTimeFormat('ru', { weekday: 'short' });

const startOfDay = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();

export const formatTime = (iso: string) => time.format(new Date(iso));

/** Compact timestamp for the conversation list. */
export function formatListTime(iso: string) {
  const d = new Date(iso);
  const days = (startOfDay(new Date()) - startOfDay(d)) / 86400000;
  if (days < 1) return time.format(d);
  if (days < 7) return weekday.format(d);
  return shortDate.format(d);
}

export function formatDayLabel(iso: string) {
  const d = new Date(iso);
  const days = (startOfDay(new Date()) - startOfDay(d)) / 86400000;
  if (days < 1) return 'Сегодня';
  if (days < 2) return 'Вчера';
  return d.getFullYear() === new Date().getFullYear() ? dayMonth.format(d) : fullDate.format(d);
}

export const sameDay = (a: string, b: string) => startOfDay(new Date(a)) === startOfDay(new Date(b));

export function formatSize(bytes: number) {
  if (bytes < 1024) return `${bytes} Б`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} КБ`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / 1024 / 1024).toFixed(1)} МБ`;
  return `${(bytes / 1024 / 1024 / 1024).toFixed(1)} ГБ`;
}

export function formatDuration(sec: number) {
  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec % 3600) / 60);
  const s = sec % 60;
  const mm = String(m).padStart(h ? 2 : 1, '0');
  return `${h ? `${h}:` : ''}${mm}:${String(s).padStart(2, '0')}`;
}
